<template>
  <CCard>
    <CCardHeader style="background:#1a3665;color:white">Email</CCardHeader>
    <CCardBody>
      <CRow>
        <CCol sm="6" lg="12">
          <CSelect
            label="Data Perhalaman"
            style="width:20%;float:left"
            :options="[1,2,3,4,5,6,7,8,9,10,11,12]"
          />
          <CInput
            label="Pencarian"
            style="width:20%;float:left;margin-right:10px"
            placeholder="Cari Data .."
          />
          <br />
          <CButton color="success" style="float:right" size="md">Tambah</CButton>
          <CButton color="warning" style="float:right;margin-right:10px" size="md">Export Excel</CButton>
          <CButton color="danger" style="float:right;margin-right:10px" size="md">Export PDF</CButton>
          <CButton color="primary" style="float:right;margin-right:10px" size="md">Print</CButton>
        </CCol>
        <CCol sm="6" lg="12">
          <CDataTable
            style="widht:100% !important"
            :items="items"
            :fields="fields"
            items-per-page-select
            :items-per-page="5"
            hover
            sorter
          >
            <template #no="{item}">
              <td class="py-2">{{ item.no }}</td>
            </template>
            <template #_status="{item}">
              <td class="py-2">{{ item._status == 1 ? 'v' : 'x' }}</td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2">
                <CButton color="primary" square size="sm" @click="toggleDetails(item, index)">
                  <font-awesome-icon icon="edit" />
                </CButton>&nbsp;&nbsp;
                <CButton color="danger" square size="sm" @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
              </td>
            </template>
          </CDataTable>
          <CPagination style="float:right" :active-page.sync="currentPage" :pages="10" responsive />
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>
<script>
const items = [
  { no: "1", nama: "Edy Supardi", divisi: "RPL", _status: 0, status: "Active" },
  {
    no: "2",
    nama: "Edy Supardi",
    divisi: "Akuntan",
    _status: 1,
    status: "Active"
  },
  {
    no: "3",
    nama: "Edy Supardi",
    divisi: "Akuntan",
    _status: 1,
    status: "Active"
  },
  { no: "4", nama: "Edy Supardi", divisi: "RPL", _status: 1, status: "Active" },
  {
    no: "5",
    nama: "Edy Supardi",
    divisi: "Akuntan",
    _status: 0,
    status: "Active"
  },
  {
    no: "6",
    nama: "Edy Supardi",
    divisi: "Akuntan",
    _status: 1,
    status: "Active"
  }
];

const fields = [
  { key: "no" },
  { key: "nama", _style: "width:40%" },
  "divisi",
  "_status",
  { key: "aksi", _style: "width:20%;" }
];

export default {
  name: "AdvancedTables",
  data() {
    return {
      items: items.map((item, id) => {
        return { ...item, id };
      }),
      fields,
      currentPage: 3,
      details: [],
      no: 1,
      collapseDuration: 0
    };
  },
  methods: {
    deleteData() {
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
              onOpen: toast => {
                toast.addEventListener("mouseenter", Swal.stopTimer);
                toast.addEventListener("mouseleave", Swal.resumeTimer);
              }
            });
            Toast.fire({
              icon: "success",
              title: "Data Berhasil Dihapus"
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    getBadge(status) {
      switch (status) {
        case "Active":
          return "success";
        case "Inactive":
          return "secondary";
        case "Pending":
          return "warning";
        case "Banned":
          return "danger";
        default:
          "primary";
      }
    },
    toggleDetails(item) {
      this.$set(this.items[item.id], "_toggled", !item._toggled);
      this.collapseDuration = 300;
      this.$nextTick(() => {
        this.collapseDuration = 0;
      });
    }
  }
};
</script>